import { environment } from '@/environments/environment';
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpParams,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { Adjunto } from '@/app/models/interface/adjunto.model';
import { CustomResponse } from '@/app/models/interface/response.model';

interface Response {
  progress: number;
  response?: CustomResponse<Adjunto> | null;
}

@Injectable({ providedIn: 'root' })
export class UploadService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'adjuntos/';

  uploadFile(file: File): Observable<Response> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http
      .post<CustomResponse<Adjunto>>(this.url, formData, {
        reportProgress: true, //# Habilita el seguimiento de progreso
        observe: 'events', //# Observa los eventos de la solicitud
      })
      .pipe(
        map((event: HttpEvent<CustomResponse<Adjunto>>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round(
                (event.loaded / (event.total || 1)) * 100,
              );
              return { progress }; //* Retorna el progreso

            case HttpEventType.Response:
              return { progress: 100, response: event.body }; //* Retorna la respuesta del servidor

            default:
              return { progress: 0 }; // Otros eventos
          }
        }),
      );
  }

  deleteFile(id: string) {
    const direction = this.url + id;
    return this.http
      .delete<string>(direction)
      .pipe(catchError((err) => handleError(err)));
  }

  getFiles(id: number) {
    const params = new HttpParams().append('id_usuario', id);
    return this.http.get<CustomResponse<Adjunto[]>>(this.url, { params }).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }
}
